import { AdminBiometricDevicesLoading } from '@/views/admin-biometric-devices/admin-biometric-devices.loading';

export default AdminBiometricDevicesLoading;
